<template>
  <div style="text-align: start;display: flex; flex-direction: column">
    <label :for="'uplodFile-container-'+size" class="v-label v-label--active theme--light "
           style="text-align: start; font-size: 12px;">{{textLabel}}</label>
    <div :id="'uplodFile-container-'+size" :style="uplodFileContainer">
      <div v-if="file!=null" class="delete-btn">
        <v-btn icon @click="deteleFile">
          <v-icon color="grey">mdi-close</v-icon>
        </v-btn>
      </div>
      <div :id="'dropfile-area-'+size" class="dropfile-area">
        <div v-if="file==null" :id="'drop-label-text-'+size" class="drop-label-text">
          <v-icon color="var(--color-3)">mdi-image-plus</v-icon>
        </div>
        <label :for="'input-file-'+size"></label>
        <input :id="'input-file-'+size" ref="file-input" accept="image/*" name="file" class="input-file"/>
        <div :id="'file-preview-'+size" class="file-preview"></div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "ImageLoader",
    props: {
      editedImage: String,
      textLabel: String,
      size: {
        type: String,
        default: "middle"
      },
        ratioW: {
            type: Number,
            default: 1
        },
        ratioH: {
            type: Number,
            default: 2
        },

    },
    data() {
      return {
        medialink: this.$root.docsUrl,
        file: null,
      }
    },
      computed:{
          uplodFileContainer(){
              let ratio= 100*this.ratioW/this.ratioH
              return {
                  "display": "flex",
                  "flex-direction": "row",
                  "height": 0,
                  "padding-bottom": `${ratio}%`,
                  "position": "relative"

              }
          }
      },

    mounted() {
      const vm = this;
      this.$root.$on("resetImageLoader", vm.deteleFile)

      let dropArea = document.getElementById('dropfile-area-' + this.size)
      ;['dragenter', 'dragover', 'dragleave', 'drop', 'mouseover', 'mouseleave', 'click'].forEach(eventName => {
        dropArea.addEventListener(eventName, vm.preventDefaults, false)
      })
      /*Добавление соответствующих классов для области drop file*/
      ;['dragenter', 'dragover'].forEach(eventName => {
        dropArea.addEventListener(eventName, vm.highlight, false)
      })
      ;['dragleave', 'drop'].forEach(eventName => {
        dropArea.addEventListener(eventName, vm.unhighlight, false)
      })

      dropArea.addEventListener('drop', vm.handleDrop, false)

      dropArea.addEventListener('mouseover', vm.hoverBlock, false)
      dropArea.addEventListener('mouseleave', vm.unhoverBlock, false)

      dropArea.addEventListener('click', vm.openFileDialog, false)

        this.loadEditedImage()
    },
    methods: {

        loadEditedImage(){
            if(this.editedImage!=null){
                this.file = this.editedImage
                let img = document.createElement('img')
                img.src = this.medialink + this.editedImage
                img.style = "width:100%"
                document.getElementById('file-preview-' + this.size).appendChild(img)
                let dropLabel = document.getElementById('drop-label-text-' + this.size)
                dropLabel.classList.add('hidden')
            }
        },

      deteleFile() {
        this.file = null
        let container = document.getElementById('file-preview-' + this.size)
        container.innerHTML = ''
        this.$emit('file-loaded', [null])
      },


      //#region Методы для drag&drop файлов

      preventDefaults(e) {
        e.preventDefault()
        e.stopPropagation()
      },
      /*Подсветить блок при драг*/
      highlight(e) {
        let dropArea = document.getElementById('dropfile-area-' + this.size)
        dropArea.classList.add('highlight')
      },

      unhighlight(e) {
        let dropArea = document.getElementById('dropfile-area-' + this.size)
        dropArea.classList.remove('highlight')
      },

      //подсветить блок при hover
      hoverBlock(e) {
        let dropArea = document.getElementById('dropfile-area-' + this.size)
        dropArea.classList.add('hovered')
      },

      unhoverBlock(e) {
        let dropArea = document.getElementById('dropfile-area-' + this.size)
        dropArea.classList.remove('hovered')
      },

      handleDrop(e) {
        let dt = e.dataTransfer
        let files = dt.files
        this.handleFiles(files)
      },

      handleFiles(files) {
        files = [...files]
        files.forEach(this.previewFile)
        this.file = files[0]
        this.$emit('file-loaded', files)
      },

      previewFile(file) {
        let reader = new FileReader()
        const vm = this;
        reader.readAsDataURL(file)
        reader.onloadend = function () {
          let img = document.createElement('img')
          img.src = reader.result
          img.style = "width:100%"
          let container = document.getElementById('file-preview-' + vm.size)
          container.innerHTML = ''
          container.appendChild(img)
        }
      },

      openFileDialog() {
        var input = document.createElement('input');
        input.type = 'file';

        input.onchange = e => {
          var files = e.target.files;
          this.handleFiles(files)
        }

        input.click();

      }

      //#endregion
    },

    watch: {
      editedImage(value) {
        if (value != null) {
          this.loadEditedImage()
        }
      }
    }
  }
</script>

<style scoped>

  .input-file {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }

  .dropfile-area {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #F5F6F9;
    border: 1px dashed var(--color-3);
    box-sizing: border-box;
  }

  .dropfile-area.highlight {
    border: 2px var(--color-blue) dashed
  }

  .dropfile-area.hovered {
    cursor: pointer;
    border: 2px var(--color-blue) dashed
  }

  .drop-label-text {
    position: relative;
    top: 50%;
    text-align: center;
  }

  .file-preview {
    overflow: hidden;
    max-width: 100%;
    max-height: 100%;
    margin-top: -24px;
  }

  .delete-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1000;
  }
</style>
